export default {
	filters: {

		formatDateTime: function( dateTimeString, options = {
			month:  'long',
			day:    'numeric',
			year:   'numeric',
			hour:   'numeric',
			minute: '2-digit'
		} ) {
			if(typeof(dateTimeString)!='string') {
				return '';
			}

			if(dateTimeString.substr( dateTimeString.length-1, 1 )==='Z') {
				dateTimeString = dateTimeString.substr( 0, dateTimeString.length-1 )+'-00:00';
			}

			let dtObj = new Date( dateTimeString );

			return dtObj.toLocaleString( 'default', options );
		},

		formatDate: function( dateTimeString, options = {
			month: 'long',
			day:   'numeric',
			year:  'numeric'
		} ) {
			let dtObj = new Date( dateTimeString );

			return dtObj.toLocaleString( 'default', options );
		},

		formatCurrency: function( val, minimumFractionDigits = 2 ) {

			let formatter = new Intl.NumberFormat( 'en-US', {
				style:                 'currency',
				currency:              'USD',
				minimumFractionDigits: minimumFractionDigits
			} );
			return formatter.format( val );
		}
	}
}


